const getLineItemProduct = (lineItem) => {
  if (lineItem.__typename === "LineItemBundle") {
    const mainBundleLineItem = lineItem.bundleLineItems.find((item) => item.isMainBundleLineItem);
    if (!mainBundleLineItem?.legacyProduct && lineItem.bundleLineItems[0]) {
      return lineItem.bundleLineItems[0].legacyProduct;
    }
    return mainBundleLineItem.legacyProduct;
  }
  return lineItem.legacyProduct;
};
export {
  getLineItemProduct
};
//# sourceMappingURL=get-line-item-product.js.map
